import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getOutstandingReport } from "./pnlService";
import OutstandingTable from "./OutstandingTable";

const OutstandingReportPage = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [totalOutstanding, setTotalOutstanding] = useState(0);
  const [loading, setLoading] = useState(true);
  
  // Date filters
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    fetchReport();
  }, []);

  const fetchReport = async () => {
    setLoading(true);
    try {
      const filters = {};
      if (startDate) filters.start_date = startDate;
      if (endDate) filters.end_date = endDate;
      
      const data = await getOutstandingReport(filters);
      setItems(data.items || []);
      setTotalOutstanding(data.total_outstanding || 0);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Outstanding Report</h3>
        <button className="btn btn-secondary btn-sm" onClick={() => navigate("/dashboard")}>
          Back to Dashboard
        </button>
      </div>
      <div className="d-flex justify-content-end mb-3">
        <div className="d-flex gap-2 align-items-end">
          <div>
            <label className="form-label small mb-1">Start Date</label>
            <input 
              type="date" 
              className="form-control form-control-sm" 
              value={startDate} 
              onChange={(e) => setStartDate(e.target.value)} 
            />
          </div>
          <div>
            <label className="form-label small mb-1">End Date</label>
            <input 
              type="date" 
              className="form-control form-control-sm" 
              value={endDate} 
              onChange={(e) => setEndDate(e.target.value)} 
            />
          </div>
          <button className="btn btn-primary btn-sm" onClick={fetchReport}>
            Filter
          </button>
        </div>
      </div>

      {loading ? (
        <div className="p-4 text-center">Loading report...</div>
      ) : (
        <OutstandingTable items={items} totalOutstanding={totalOutstanding} />
      )}
    </div>
  );
};

export default OutstandingReportPage;
